<template>
  <div :style="divStyle">
    <p>当前正在进行第 {{ current + 1 }} 步</p>
    <Steps :current="current">
      <Step title="步骤-1" content="选择筛选方式及设备信息"></Step>
      <Step title="步骤-2" content="选取设备"></Step>
      <Step title="步骤-3" content="充值"></Step>
      <Step title="步骤-4" content="执行"></Step>
    </Steps>
    <div
      style="width:30%; left:30%; position:relative; margin-top:15px;"
      v-show="showStep1"
    >
      <Form ref="formStep1" :label-width="120" :model="formItem">
        <FormItem label="设备检索条件：">
          <Select
            v-model="formItem.selectCondition"
            @on-change="changeCondition"
          >
            <Option value="idCard">身份证号</Option>
            <Option value="meterId">设备编号</Option>
            <Option value="meterType">设备类型</Option>
            <Option value="address">地址</Option>
          </Select>
        </FormItem>
        <FormItem label=" 输入或选择条件：">
          <Select
            v-model="formItem.selectMeterType"
            v-if="showSelectMeterType"
            @on-change="step1CheckNext"
          >
            <Option
              v-for="item in meterTypeData"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Cascader
            :data="addressData"
            change-on-select
            filterable
            transfer
            @on-change="choiceAll"
            v-if="showAddressData"
          ></Cascader>
          <Input
            v-model="formItem.inputIdCard"
            @on-change="step1CheckNext"
            placeholder="请输入身份证号"
            v-if="showInputIdCard"
          ></Input>
          <Input
            v-model="formItem.inputMeterId"
            @on-change="step1CheckNext"
            placeholder="请输入设备编号"
            v-if="showInputMeterId"
          ></Input>
        </FormItem>
      </Form>
    </div>
    <div style="width:100%; left:0%; position:relative; margin-top:15px;">
      <expandStep2
        ref="step2"
        v-show="showStep2"
        v-on:listenToChild2EventForButton="step2CheckNext"
      ></expandStep2>
    </div>
    <div style="width:100%; left:0%; position:relative; margin-top:15px;">
      <rechargeStep3
        ref="step3"
        v-show="showStep3"
        v-on:listenToChild3EventForButton="nextEvent"
      ></rechargeStep3>
    </div>
    <div
      style="width:100%; text-align:center; position:relative; margin-top:15px;"
    >
      <expandStep4
        ref="step4"
        :result="result"
        :msg="msg"
        v-if="showStep4"
        :on-ok="callBackReturn"
      ></expandStep4>
    </div>
    <div>
      <Button
        class="button"
        type="primary"
        @click="pre"
        :disabled="disabledButtonPre"
        >上一步</Button
      >
      <Button
        class="button"
        type="primary"
        @click="next"
        :disabled="disabledButtonNext"
        >下一步</Button
      >
    </div>
  </div>
</template>
<script>
import expandStep2 from "./expand/InstructionsDetailedStep2.vue";
import rechargeStep3 from "./expand/RechargeStep3.vue";
import expandStep4 from "./expand/opResult.vue";
export default {
  name: "recharge",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    },
  },
  data() {
    return {
      disabledButtonPre: true,
      disabledButtonNext: true,
      current: 0,
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      showSelectMeterType: false,
      showAddressData: false,
      showInputIdCard: false,
      showInputMeterId: false,
      addressDataSelect: "",
      meterTypeData: [],
      addressData: [],
      formItem: {
        selectCondition: "",
        selectMeterType: "",
        inputIdCard: "",
        inputMeterId: "",
      },
      viewMeterDetailed: {},
      disabledTooltip: true,
      result: "",
      msg: "",
    };
  },
  created() {
    var that = this;
    $.ajax({
      url: "/api/getAddressTree",
      contentType: "application/json",
      type: "get",
      dataType: "json",
      success: function(data) {
        if (data.errorCode != 0) {
          that.$Notice.error({
            title: "异常",
            desc: data.errorInfo,
          });
          return;
        }

        that.addressData = data.body[0].children;
      },
      error: function(textStatus) {
        that.$Notice.error({
          title: "异常",
          desc: "接口请求异常",
        });
      },
    });

    $.ajax({
      url: "/api/getMeterTypeInfo",
      contentType: "application/json",
      type: "get",
      dataType: "json",
      success: function(data) {
        if (data.errorCode != 0) {
          that.$Notice.error({
            title: "异常",
            desc: data.errorInfo,
          });
          return;
        }

        that.meterTypeData = data.body.resultList;
      },
      error: function(textStatus) {
        that.$Notice.error({
          title: "异常",
          desc: "接口请求异常",
        });
      },
    });
  },
  methods: {
    step1CheckNext() {
      if (
        this.formItem.selectCondition != null &&
        this.formItem.selectCondition != "" &&
        ((this.formItem.selectMeterType != null &&
          this.formItem.selectMeterType != "") ||
          (this.formItem.inputIdCard != null &&
            this.formItem.inputIdCard != "") ||
          (this.formItem.inputMeterId != null &&
            this.formItem.inputMeterId != "") ||
          (this.addressDataSelect != null && this.addressDataSelect != ""))
      ) {
        this.nextEvent(false);
      } else {
        this.nextEvent(true);
      }
    },
    step2CheckNext(param) {
      if (param != -1) {
        this.nextEvent(false);
      } else {
        this.nextEvent(true);
      }
    },
    nextEvent(param) {
      this.disabledButtonNext = param;
    },
    next() {
      if (this.current == 3) {
      } else if (this.current == 0) {
        this.current += 1;
        this.showStep1 = false;
        this.showStep2 = true;
        this.disabledButtonNext = true;
        this.disabledButtonPre = false;
        this.viewMeterDetailed[
          "addressLowestLevelAddressIds"
        ] = this.addressDataSelect;
        this.viewMeterDetailed["customerIdcard"] = this.formItem.inputIdCard;
        this.viewMeterDetailed["meterId"] = this.formItem.inputMeterId;
        this.viewMeterDetailed["meterType"] = this.formItem.selectMeterType;
        this.$refs.step2.currentPage = 1;
        this.$refs.step2.getMeterList(this.viewMeterDetailed);
      } else if (this.current == 1) {
        this.disabledButtonNext = false;
        this.showStep2 = false;
        this.showStep3 = true;
        //this.disabledButtonNext = true;
        this.$refs.step3.getRechargeBaseInfo(
          this.$refs.step2.data[this.$refs.step2.selectIndex].meterId
        );
        this.$refs.step3.getRecordPage(
          this.$refs.step2.data[this.$refs.step2.selectIndex].meterId
        );
        this.current += 1;
      } else if (this.current == 2) {
        this.$refs.step3.commitRecharge();
      } else {
        this.current += 1;
      }
    },
    step3to4(param) {
      this.showStep3 = false;
      this.showStep4 = true;
      this.disabledButtonNext = true;
      this.disabledButtonPre = true;
      this.current += 1;
      if (param) {
        this.result = "success";
        this.msg = "充值成功，点击返回";
      } else {
        this.result = "fail";
        this.msg = "充值失败，点击返回";
      }
    },
    pre() {
      if (this.current == 0) {
      } else if (this.current == 1) {
        this.showStep1 = true;
        this.showStep2 = false;
        this.disabledButtonNext = false;
        this.disabledButtonPre = true;
        this.current -= 1;
      } else if (this.current == 2) {
        this.showStep2 = true;
        this.showStep3 = false;
        this.disabledButtonNext = false;
        this.current -= 1;
      } else if (this.current == 3) {
        this.showStep3 = true;
        this.showStep4 = false;
        this.current -= 1;
      } else {
        this.current -= 1;
      }
    },
    changeCondition() {
      this.showSelectMeterType = false;
      this.showAddressData = false;
      this.showInputIdCard = false;
      this.showInputMeterId = false;
      this.formItem.selectMeterType = null;
      this.addressDataSelect = null;
      this.formItem.inputIdCard = null;
      this.formItem.inputMeterId = null;
      switch (this.formItem.selectCondition) {
        case "meterId":
          this.showInputMeterId = true;
          break;
        case "idCard":
          this.showInputIdCard = true;
          break;
        case "meterType":
          this.showSelectMeterType = true;
          break;
        case "address":
          this.showAddressData = true;
          break;
      }
      this.step1CheckNext();
    },
    choiceAll(data) {
      if (data.length > 0) {
        this.addressDataSelect = data.reverse()[0].toString(); //当复选框选中时则会打印出选中的内容
      } else {
        this.addressDataSelect = null;
      }
      this.step1CheckNext();
    },
    callBackReturn() {
      this.current = 0;
      this.disabledButtonNext = false; //按钮可用
      this.showStep1 = true;
      this.showStep2 = false;
      this.showStep3 = false;
      this.showStep4 = false;
    },
  },
  components: { expandStep2, rechargeStep3, expandStep4 },
};
</script>
<style>
.button {
  margin-right: 5px;
}
</style>
